import React from "react"
import { css } from "@jsUtils"

import Styles from "./headline.module.scss"

/**
 * Eyebrow with colored line
 * @param {object} props - react props
 * @param {string} props.color - line color
 * @param {string} props.emColor - color of <em> children (set in CMS using *text*)
 * @param {object} props.children - child components
 * @param {string} props.className - class name
 * @param {string} props.style - inline css styles
 * @param {string} props.size - headline size
 */

const Headline = props => {
  const { children, color, emColor, size, className, style, subhead } = props
  const H = `h${size}`
  return subhead ? (
    <H
      className={css(
        Styles.headline,
        Styles[`h${size}`],
        color && Styles[`c_${color}`],
        emColor && Styles[`em_${emColor}`],
        className
      )}
      style={style}
      dangerouslySetInnerHTML={{ __html: children }}
    />
  ) : (
    <H
      className={css(
        Styles.headline,
        Styles[`h${size}`],
        color && Styles[`c_${color}`],
        emColor && Styles[`em_${emColor}`],
        className
      )}
      style={style}
    >
      {children}
    </H>
  )
}

export default Headline
